// React Imports
import { ReactElement } from "react";

// Local Imports
import { Notification } from "../../../../models/notification.model";
import moment from "moment";

interface ViewNotificationProps {
  selectedNotification: Notification | undefined;
  onCancel: () => void;
}

const ViewNotification: React.FC<ViewNotificationProps> = ({
  selectedNotification,
  onCancel,
}: ViewNotificationProps): ReactElement => {
  return (
    <div className="flex flex-col w-full px-5 box-border">
      <div className="inline-flex flex-col justify-start items-start gap-6">
        <div className="self-stretch px-5 inline-flex justify-start items-start gap-8">
          <div className="flex-1 inline-flex flex-col justify-center items-center gap-3">
            <div className="self-stretch px-3 inline-flex justify-center items-center gap-2.5">
              <div className="flex-1 h-6 text-center justify-center text-sky-900 text-xl font-semibold font-['Montserrat']">
                View Message
              </div>
            </div>
          </div>
          <span
            className="cursor-pointer text-gray-500 text-xl"
            onClick={onCancel}
          >
            X
          </span>
        </div>
        <div className="w-full px-5 pt-6 pb-5 bg-[#EEE] rounded-xl outline outline-[1.50px] outline-offset-[-1.50px] outline-gray-200 flex flex-col justify-start items-start gap-4">
          <div className="self-stretch pb-1  border-b border-gray-200 inline-flex justify-start items-start gap-1.5">
            <div className="flex-1 justify-center">
              <span className="text-neutral-600 text-xs font-semibold font-['Montserrat']">
                To:{" "}
              </span>
              <span className="text-sky-900 text-xs font-semibold font-['Montserrat']">
                {" "}
              </span>
              {selectedNotification?.type === "GENERIC" ? (
                <span className="text-sky-900 text-xs font-medium">
                  All users
                </span>
              ) : (
                <span className="text-sky-900 text-xs font-medium">
                  Selected users
                </span>
              )}
            </div>
            <div className="justify-center">
              <span className="text-neutral-600 text-xs font-semibold font-['Montserrat']">
                At :{" "}
              </span>
              <span className="text-neutral-600 text-xs font-medium font-['Montserrat']">
                {moment(selectedNotification?.createdAt).format("MMM D, YYYY")}
              </span>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-end items-center gap-8">
            <div className="self-stretch flex flex-col justify-center items-end gap-4">
              <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="self-stretch justify-center text-sky-900 text-xs font-semibold font-['Montserrat'] underline">
                  {selectedNotification?.title}
                </div>
                <div className="self-stretch justify-center text-neutral-700 text-xs font-medium font-['Montserrat']">
                  {selectedNotification?.body}
                  <br />
                </div>
              </div>
              <div className="self-stretch flex flex-col justify-start items-end gap-2">
                <div className="self-stretch text-right justify-center text-sky-900 text-xs font-semibold font-['Montserrat'] underline">
                  {selectedNotification?.titleAr}
                </div>
                <div className="self-stretch text-right justify-center text-neutral-700 text-xs font-medium font-['Montserrat']">
                  {selectedNotification?.bodyAr}
                  <br />
                </div>
              </div>
            </div>
            {selectedNotification?.image && (
              <img
                src={selectedNotification?.image}
                alt="notification"
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewNotification;
